import React, { useState, useEffect, useRef } from "react";
import { useDarkMode } from '../../contexts/DarkModeContext';
import "./TrustedBy.css";

function TrustedBy() {
  const { isDarkMode } = useDarkMode();
  const [counters, setCounters] = useState({
    trust: 0,
    teachers: 0,
    lessons: 0,
    students: 0
  });
  
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const stats = [
      { id: 4, icon: "/LIKE.png", number: "91%", text: "ثقة المستخدمين", key: "trust", target: 91, suffix: "%" },
      { id: 3, icon: "/teacher.png", number: "60+", text: "مدرسين ذو خبرة", key: "teachers", target: 60, suffix: "+" },
      { id: 2, icon: "/studentStage.png", number: "1k+", text: "حصص دراسية", key: "lessons", target: 1000, suffix: "+" },
      { id: 1, icon: "/ThreeStudents.png", number: "2k+", text: "طلاب اعجبهم المحتوى", key: "students", target: 2000, suffix: "+" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
          startCounters();
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  const startCounters = () => {
    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    stats.forEach((stat) => {
      const { key, target } = stat;
      let current = 0;
      const increment = target / steps;

      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        
        setCounters(prev => ({
          ...prev,
          [key]: Math.floor(current)
        }));
      }, stepDuration);
    });
  };

  return (
    <section className={`trusted-by ${isDarkMode ? 'dark-mode' : 'light-mode'}`} ref={sectionRef}>
      {/* Floating Animation Elements */}
      <div className="floating-elements">
        <div className="floating-element element-1">⭐</div>
        <div className="floating-element element-2">🎓</div>
        <div className="floating-element element-3">📚</div>
        <div className="floating-element element-4">🏆</div>
        <div className="floating-element element-5">💎</div>
        <div className="floating-element element-6">✨</div>
        <div className="floating-element element-7">🌟</div>
        <div className="floating-element element-8">💫</div>
        <div className="floating-element element-9">🔮</div>
        <div className="floating-element element-10">🎯</div>
        <div className="floating-element element-11">🚀</div>
        <div className="floating-element element-12">💎</div>
      </div>

      {/* ✅ العنوان مع الخطين */}
      <div className="section-header">
        <span className="line"></span>
        <h2>موثوق به من قبل المدرسين</h2>
        <span className="line"></span>
      </div>

      {/* ✅ الكروت */}
      <div className="container">
        <div className="row justify-content-center">
          {stats.map((item) => (
            <div className="col-md-3 col-6 col-12 mb-4" key={item.id}>
              <div className="stat-card">
                <div className="icon-circle-absolute">
                  <img src={item.icon} alt="icon" />
                </div>
                <h3 className="number">
                  {counters[item.key]}{item.suffix}
                </h3>
                <p className="description">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrustedBy;
